export default __webpack_public_path__ + "static/media/editor-animations.cf447e40.webp";